export var ADD_SNACK = 'ADD_SNACK';
export var REMOVE_SNACK = 'REMOVE_SNACK';
export var REMOVE_SNACK_BY_UNIQUE_ID = 'REMOVE_SNACK_BY_UNIQUE_ID';
export var showSnack = function showSnack(payload) {
  return function (dispatch, getState) {
    var _getState = getState(),
      snackbar = _getState.snackbar;
    var snacks = snackbar.snacks;
    var snack = payload;
    if (snacks.length !== 0) {
      var _snack = snacks.find(function (snack) {
        return snack.id === payload.id;
      });
      if (_snack) {
        _snack.count ? _snack.count++ : _snack.count = 2;
        _snack.text = payload.text + ' (' + _snack.count.toString() + ')';
        dispatch(dismissSnackByUniqueId(_snack.uniqueId));
      }
    }
    dispatch(addSnack(snack));
  };
};
export var dismissSnack = function dismissSnack(payload) {
  return {
    type: REMOVE_SNACK,
    payload: payload
  };
};
export var dismissSnackByUniqueId = function dismissSnackByUniqueId(payload) {
  return {
    type: REMOVE_SNACK_BY_UNIQUE_ID,
    payload: payload
  };
};
var addSnack = function addSnack(payload) {
  return {
    type: ADD_SNACK,
    payload: Object.assign({}, payload, {
      uniqueId: Date.now()
    })
  };
};